import { handleHttpResponse } from "../../utils/http_response_utils";

export const getAutoShutdownStatus = async () => {
  /** Get database auto-shutdown status */
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/rds/get-auto-shutdown-status", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const enableAutoShutdown = async () => {
  /** Enable database auto-shutdown */
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/rds/enable-auto-shutdown", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const disableAutoShutdown = async () => {
  /** Disable database auto-shutdown */
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/rds/disable-auto-shutdown", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};
